/**
 * 专业api
 * 专业api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../basic/model/CreatedVo';
import MajorCreateForm from '../../basic/model/MajorCreateForm';
import MajorEditForm from '../../basic/model/MajorEditForm';
import MajorVo from '../../basic/model/MajorVo';
import PagingMajorVo from '../../basic/model/PagingMajorVo';
import UpdatedVo from '../../basic/model/UpdatedVo';
  /**
   * Major service.
   * @module basic/api/MajorApi
   * @version 0.2.0
   */

  /**
   * Constructs a new MajorApi. 
   * @alias module:basic/api/MajorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 新增专业
     * @param {module:basic/model/MajorCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/CreatedVo}
     */
this.addMajor = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addMajor";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/major/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 新增开设分院
     * @param {Integer} id 专业id
     * @param {Integer} companyId 开设院校id
     * @param {Integer} deptId 分院id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/CreatedVo}
     */
this.addMajorCompany = function(id, companyId, deptId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling addMajorCompany";
      }

      // verify the required parameter 'companyId' is set
      if (companyId == undefined || companyId == null) {
        throw "Missing the required parameter 'companyId' when calling addMajorCompany";
      }

      // verify the required parameter 'deptId' is set
      if (deptId == undefined || deptId == null) {
        throw "Missing the required parameter 'deptId' when calling addMajorCompany";
      }


      var pathParams = {
        'id': id,
        'companyId': companyId
      };
      var queryParams = {
        'deptId': deptId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/major/{id}/company/{companyId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询专业
     * @param {Integer} pageNum 当前页码
     * @param {Integer} gradationId 专业层次id
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.companyId 开设院校id
     * @param {String} opts.text 搜索名称或者编号
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/PagingMajorVo}
     */
this.findPagingMajor = function(pageNum, gradationId, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingMajor";
      }

      // verify the required parameter 'gradationId' is set
      if (gradationId == undefined || gradationId == null) {
        throw "Missing the required parameter 'gradationId' when calling findPagingMajor";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'gradationId': gradationId,
        'companyId': opts['companyId'],
        'text': opts['text']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingMajorVo;
      return this.apiClient.callApi(
        '/api/major/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 返回全部专业
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.gradationId 专业层次
     * @param {Integer} opts.companyId 开设院校id
     * @param {String} opts.text 搜索名称或者编号
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:basic/model/MajorVo>}
     */
this.getMajorlist = function(opts) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'gradationId': opts['gradationId'],
        'companyId': opts['companyId'],
        'text': opts['text']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [MajorVo];
      return this.apiClient.callApi(
        '/api/major/list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除专业
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.removeMajor = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling removeMajor";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/major/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除开设院校
     * @param {Integer} id 专业idid
     * @param {Integer} companyId 开设院校id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.removeMajorCompany = function(id, companyId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling removeMajorCompany";
      }

      // verify the required parameter 'companyId' is set
      if (companyId == undefined || companyId == null) {
        throw "Missing the required parameter 'companyId' when calling removeMajorCompany";
      }


      var pathParams = {
        'id': id,
        'companyId': companyId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/major/{id}/company/{companyId}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改专业
     * @param {Integer} id id
     * @param {module:basic/model/MajorEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.updateMajor = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateMajor";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateMajor";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/major/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改开设院校
     * @param {Integer} id 专业idid
     * @param {Integer} companyId 开设院校id
     * @param {Integer} deptId 分院id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.updateMajorCompany = function(id, companyId, deptId) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateMajorCompany";
      }

      // verify the required parameter 'companyId' is set
      if (companyId == undefined || companyId == null) {
        throw "Missing the required parameter 'companyId' when calling updateMajorCompany";
      }

      // verify the required parameter 'deptId' is set
      if (deptId == undefined || deptId == null) {
        throw "Missing the required parameter 'deptId' when calling updateMajorCompany";
      }


      var pathParams = {
        'id': id,
        'companyId': companyId
      };
      var queryParams = {
        'deptId': deptId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/major/{id}/company/{companyId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
